
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputComponent from '../InputComponent';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';

import Checkbox from '@material-ui/core/Checkbox';
import DropDownList from '../DropDownList';


import FormControlLabel from '@material-ui/core/FormControlLabel';


import { getUIText, generateUid, getUniqueName } from '../../utils/index';

import { getValue } from '../../utils/calculations-helper';

import { PRODUCTS } from '../../modules/data/products';

import { solveLambdaArray } from '../../utils/thermal-math';

const defaultItem = {
  'custom': 'true',
  'name': '',
  'Standard-thickness': '30, 50',
  'MST': 400,
  'Emissivity': 0.95,
  'Area-of-usage': '',
  'nominal-density': 0,

  'lambdaATemp': 10,
  'lambdaA': 0.034,
  'lambdaBTemp': 50,
  'lambdaB': 0.037,
  'lambdaCTemp': 100,
  'lambdaC': 0.042,
  'lambdaDTemp': 150,
  'lambdaD': 0.049,

  'flatSurfaceChecked': false,
  'pipeChecked': false,
  'circularDuctChecked': false,
  'rectangularDuctChecked': false,
  'circularTankChecked': false,
  'rectangularTankChecked': false,
  'Support-possible': false,
};

function getTempArrayForCalculationLambda(data) {
  return [getValue(data.lambdaATemp, 'float'), getValue(data.lambdaBTemp, 'float'), getValue(data.lambdaCTemp, 'float'), getValue(data.lambdaDTemp, 'float')];
}

function getLambdaArrayForCalculationLambda(data) {
  return [getValue(data.lambdaA, 'float'), getValue(data.lambdaB, 'float'), getValue(data.lambdaC, 'float'), getValue(data.lambdaD, 'float')];
}

function getFormattedLambdaArray(data) {
  return {
    'a': data[0] ? data[0] : '',
    'b': data[1] ? data[1] : '',
    'c': data[2] ? data[2] : '',
    'd': data[3] ? data[3] : '',
  };
}

class Product extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...defaultItem,
    };
  }

  onCreateNewItem() {
    const { translations, app, create, items} = this.props;
    const newItem = {
      ...defaultItem,
      ...getFormattedLambdaArray(solveLambdaArray(getTempArrayForCalculationLambda(defaultItem), getLambdaArrayForCalculationLambda(defaultItem))),
      name: getUniqueName(items, getUIText('SETTINGS-CUSTOM_PRODUCT_HEADER', app.language, translations)),
      Nid: generateUid()
    };

    this.setState({
      id: newItem.Nid
    });
    create({item: newItem, type: PRODUCTS});
  }

  onDeleteItem(id, e) {
    const { items, remove } = this.props;
    if(items) {
      const index = items.findIndex( (item ) => {
        if(item.Nid === id) {
          return true;
        }
        return false;
      });

      const newItems = [
        ...items.slice(0, index),
        ...items.slice(index + 1)
      ];

      let newId = '-1';
      if(newItems[index]) {
        newId = newItems[index].Nid;
      } else if (newItems[index - 1]) {
        newId = newItems[index - 1].Nid;
      }

      remove({id: items[index].Nid, type: PRODUCTS});
      this.setState({
        id: newId
      });
    }
  }

  onPatchItem(id, updateItem, e) {
    const { items, patch } = this.props;

    if(items) {
      const updatedItem = items.find( item => {
        if(item.id === id) {
          return true;
        }
        return false;
      });

      let areaOfUsage = [];
      if(updateItem) {
        if(updateItem.flatSurfaceChecked) {
          areaOfUsage.push('Flat surface');
        }
        if(updateItem.pipeChecked) {
          areaOfUsage.push('Pipe');
        }
        if(updateItem.circularDuctChecked) {
          areaOfUsage.push('Circular duct');
        }
        if(updateItem.rectangularDuctChecked) {
          areaOfUsage.push('Rectangular duct');
        }
        if(updateItem.circularTankChecked) {
          areaOfUsage.push('Circular tank');
        }
        if(updateItem.rectangularTankChecked) {
          areaOfUsage.push('Flat surface');
        }

        updateItem['Area-of-usage'] = areaOfUsage.toString();
        updateItem = {
          ...updateItem,
          ...getFormattedLambdaArray(solveLambdaArray(getTempArrayForCalculationLambda(updateItem), getLambdaArrayForCalculationLambda(updateItem)))
        };
      }
      patch({item: updateItem, type: PRODUCTS});
    }
  }

  render() {
    const { translations, app, items} = this.props;

    let data = [];
    if(items) {
      data = items.filter( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return true;
        }
      });
    }

    data = data.map( item => {
      return {...item, id: item.Nid};
    });

    const selectedItem = data.find( (item) => {
      if(item.Nid === this.state.id) {
        return true;
      }
      return false;
    });

    return (
      <div className="settings-product">
        <Grid container spacing={8}>
          <Grid item xs={6} className="setting-dropdownlist-container">
              <DropDownList
                data={data}
                selectedItem={this.state.id}
                label={getUIText('SETTINGS-CUSTOM_PRODUCTS', app.language, translations)}
                onChange={ (id) => {this.setState({id: id});} } />
          </Grid>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <div className="settings-buttons" >
              <Button color="primary" onClick={this.onCreateNewItem.bind(this)} >{getUIText('GENERAL-NEW', app.language, translations)}</Button>
              <Button color="primary" disabled={this.state.id ? false : true} onClick={this.onDeleteItem.bind(this, this.state.id)}  >{getUIText('GENERAL-DELETE', app.language, translations)}</Button>
            </div>
          </Grid>
          {selectedItem ? <Grid item xs={12} md={6}>
            <InputComponent
              label={getUIText('SETTINGS-PRODUCT_NAME', app.language, translations)}
              value={selectedItem ? selectedItem['name'] : ''}
              type="string"
              className="full-width"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'name': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-THICKNESS', app.language, translations)}
              value={selectedItem ? selectedItem['Standard-thickness'] : ''}
              type="string"
              className="full-width"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Standard-thickness': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-MST', app.language, translations)}
              value={selectedItem ? selectedItem['MST'] : ''}
              type="number"
              unit="°C"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'MST': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-EMISSITY', app.language, translations)}
              value={selectedItem ? selectedItem['Emissivity'] : ''}
              type="number"
              unit="ε"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Emissivity': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-NOMINAL_DENSITY', app.language, translations)}
              value={selectedItem ? selectedItem['nominal-density'] : ''}
              type="number"
              unit="kg/m³"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'nominal-density': value})}
              />

          </Grid> : null }
          {selectedItem ? <Grid item xs={12} md={6}>
            <div className="lambda-items">
              <div className="lambda-headers">
                <div className="lambda-header" >
                  <b>{getUIText('SETTINGS-TEMPERATURE', app.language, translations)}</b>
                </div>
                <div className="lambda-header" >
                  <b>{getUIText('SETTINGS-LAMBDA_TEXT', app.language, translations)}</b>
                </div>
              </div>
              <div className="lambda-item">
                <Input
                  className="col-left"
                  inputProps={{type: 'number', pattern: '\d*'}}
                  value={selectedItem ? selectedItem.lambdaATemp : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaATemp: e.target.value})}
                  />
                <div className="col-center">°C =</div>
                <Input
                  className="col-right"
                  inputProps={{type: 'number', pattern: '\d*', step: '0.001'}}
                  value={selectedItem ? selectedItem.lambdaA : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaA: e.target.value})}
                  />
                <div className="col-end">W/mk</div>
              </div>
              <div className="lambda-item">
                <Input
                  className="col-left"
                  inputProps={{type: 'number', pattern: '\d*'}}
                  value={selectedItem ? selectedItem.lambdaBTemp : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaBTemp: e.target.value})}
                  />
                <div className="col-center">°C =</div>
                <Input
                  className="col-right"
                  inputProps={{type: 'number', pattern: '\d*', step: '0.001'}}
                  value={selectedItem ? selectedItem.lambdaB : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaB: e.target.value})}
                  />
                <div className="col-end">W/mk</div>
              </div>
              <div className="lambda-item">
                <Input
                  className="col-left"
                  inputProps={{type: 'number', pattern: '\d*'}}
                  value={selectedItem ? selectedItem.lambdaCTemp : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaCTemp: e.target.value})}
                  />
                <div className="col-center">°C =</div>
                <Input
                  className="col-right"
                  inputProps={{type: 'number', pattern: '\d*', step: '0.001'}}
                  value={selectedItem ? selectedItem.lambdaC : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaC: e.target.value})}
                  />
                <div className="col-end">W/mk</div>
              </div>
              <div className="lambda-item">
                <Input
                  className="col-left"
                  inputProps={{type: 'number', pattern: '\d*', step: '0.001'}}
                  value={selectedItem ? selectedItem.lambdaDTemp : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaDTemp: e.target.value})}
                  />
                <div className="col-center">°C =</div>
                <Input
                  className="col-right"
                  inputProps={{type: 'number', pattern: '\d*', step: '0.001'}}
                  value={selectedItem ? selectedItem.lambdaD : ''}
                  onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, lambdaD: e.target.value})}
                  />
                <div className="col-end">W/mk</div>
              </div>
            </div>
          </Grid> : null }

          {selectedItem ? <Grid item xs={12} md={6} >
            <div className="area-of-usage">
              <div className="area-of-usage-header">{getUIText('SETTINGS-AREA_OF_USAGE', app.language, translations)}</div>
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('flatSurfaceChecked') ? selectedItem.flatSurfaceChecked : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, flatSurfaceChecked: value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('CALCULATION-FLAT_SURFACE', app.language, translations)}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('pipeChecked') ? selectedItem.pipeChecked : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, pipeChecked: value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('CALCULATION-PIPE', app.language, translations)}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('circularDuctChecked') ? selectedItem.circularDuctChecked : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, circularDuctChecked: value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('CALCULATION-CIRCULAR_DUCT', app.language, translations)}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('rectangularDuctChecked') ? selectedItem.rectangularDuctChecked : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, rectangularDuctChecked: value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('CALCULATION-RECTANGULAR_DUCT', app.language, translations)}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('circularTankChecked') ? selectedItem.circularTankChecked : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, circularTankChecked: value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('CALCULATION-CIRCULAR_TANK', app.language, translations)}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('rectangularTankChecked') ? selectedItem.rectangularTankChecked : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, rectangularTankChecked: value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('CALCULATION-RECTANGULAR_TANK', app.language, translations)}
                />
            </div>
          </Grid> : null }

          {selectedItem ? <Grid item xs={12} md={6} >
            <div className="area-of-usage">
              <div className="area-of-usage-header">{getUIText('INSULATION-SUPPORTING', app.language, translations)}</div>
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedItem ? selectedItem.hasOwnProperty('Support-possible') ? selectedItem['Support-possible'] : false : false}
                      onChange={(event, value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Support-possible': value})}
                    />
                  }
                  className="checkBoxContainer"
                  label={getUIText('INSULATION-SUPPORTING', app.language, translations)}
                />
            </div>
          </Grid> : null }
        </Grid>
      </div>
    );
  }
}

// onChange={(event, value) => onCalculateTemperatureChange(value)}

Product.propTypes = {

  translations: PropTypes.any,
  app: PropTypes.any,
  create: PropTypes.any,
  items: PropTypes.any,
  remove: PropTypes.any,
  patch: PropTypes.any,
};

export default Product;
